import type { GlobalCart2 } from '~/amplienceTypes/schemas/imported/global-cart-schema';
import { CART_ITEMS_VARIABLE } from '~/utilities/constants/amplienceVariables';

interface Params {
  content?: GlobalCart2;
  amount: number;
}

interface ReturnType {
  cartAriaLabel: string;
}

export function getCartAriaLabel({ content, amount }: Params): ReturnType {
  const contentString =
    content?.cartAccessibilityLabels?.itemsInCart ||
    `Items in shopping cart: ${CART_ITEMS_VARIABLE}`;

  return {
    cartAriaLabel: contentString.replace(CART_ITEMS_VARIABLE, amount.toString()),
  };
}
